export default {
  app: {
    name: "EpicMas Affiliate",
    full: "EpicMas Affiliate",
    minimized: "AFF"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_id: "Search by ID",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"",
  successful_change_password: "You have successfully change password.",
  change_disable_confirm: "Are you sure you want to change \"{name}\" to disable?",
  select_option: "Select your option",
  no_data_available: "No Data Available",
  no_rating_available: "No Rating Available",
  successful_update_security: "You have successfully update security.",
  successful_disable_security: "You have successfully disable security.",
  update_security_confirm: "Are you sure you want to update security?",
  disable_security_confirm: "Are you sure you want to disable security?",
  change_operator_status_confirm: "Are you sure you want to change operator \"{name}\" status?",
  change_member_status_confirm: "Are you sure you want to change member \"{name}\" status?",
  approve_ticket_confirm: "Are you sure you want to approve the ticket?",
  reject_ticket_confirm: "Are you sure you want to reject the ticket?",
  change_self_operate_confirm: "Are you sure you want to change \"{name}\" operation mode?",
  change_bank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_ibank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_package_own_status_confirm: "Are you sure want to change \"{name}\" package own status?",
  knock_off_promo_confirm: "Are you sure you want to knock off \"{name}\" promotion?",
  successful_promo_package_download: "You have successfully download promotion package.",
  successful_update_account_setup: "You have successfully update account setup.",
  unblock_member_confirm: "Are you sure you want to unblock member \"{name}\"?",
  unblock_operator_confirm: "Are you sure you want to unblock operator \"{name}\"?",
  block_sub_account_confirm: "Are you sure you want to block sub account \"{name}\"?",
  unblock_sub_account_confirm: "Are you sure you want to unblock sub account \"{name}\"?",
  successful_create_secondary_account: "You have successfully create secondary account.",
  update_account_password_confirm: "Are you sure you want to update account password?",
  successful_update_account_password: "You have successfully update account password.",
  update_account_password_cancel: "Are you sure you want to cancel update account password?",
  change_affiliate_status_confirm: "Are you sure you want to change affiliate \"{name}\" status?",
  approve_affiliate_confirm: "Are you sure you want to approve \"{name}\" as affiliate?",
  please_setup_bank_acc: "Please setup bank account before raise withdraw ticket.",
  successful_affiliate_signup: "Your affiliate application have been successfully submitted.",
  tac_code_has_been_sent: "TAC code has been sent to your phone number.",
  new_tac_code_has_been_sent: "New TAC code has been sent to your phone number.",
  successful_validate_tac_code: "You have successfully validate TAC code.",
};
